import { ButtonHeading } from 'components'
import { Images } from 'constants'
import React, { useContext, useEffect } from 'react'
import { FaCheck } from 'react-icons/fa6'
import { IoArrowForwardOutline } from 'react-icons/io5'
import { RxCross1 } from 'react-icons/rx'
import testImg from '../../assets/img/star_popular.png'
import { useNavigate } from 'react-router-dom'
import { planComparision, subscriptionListApi } from '_services'
import { StorageServices } from 'utils'
import { set } from 'lodash'
import toast from 'react-hot-toast'
import Loading from 'pages/Loading'
import { UserContext } from 'context'
import { FaArrowLeftLong } from "react-icons/fa6";
import './subscription.css'
import ComparisonTable from './ComparisonTable';

const Subscription = () => {

    const navigate = useNavigate();
    const { setSubscriptionDetails } = useContext(UserContext);
    const [subscriptionPlans, setSubscriptionPlans] = React.useState({
        basic: {},
        premium: {},
        premiumPlus: {},
        enterprise_Plan: {},

    });
    const [subscriptionList, setSubscriptionList] = React.useState({})
    const [comparisionPlans, setComparisionPlans] = React.useState({})
    const [isLoading, setIsLoading] = React.useState(false);
    const [containerWidth, setContainerWidth] = React.useState("1450px");
    const [boxWidth, setBoxWidth] = React.useState("calc(25% - 9px)");

    const handleBuyBasicPlan = () => {
        setSubscriptionDetails(subscriptionPlans.basic);
        navigate("/subscription/plan_detail");
    };

    const handleBuyPremiumPlan = () => {
        setSubscriptionDetails(subscriptionPlans.premium);
        navigate("/subscription/plan_detail");
    };

    const handleBuyEnterPrisePlan = () => {
        setSubscriptionDetails(subscriptionPlans.enterprise_Plan);
    };

    const handleBuyPremiumPlusPlan = () => {
        setSubscriptionDetails(subscriptionPlans.premiumPlus);
        navigate("/subscription/plan_detail");
    }



    useEffect(() => {
        getSubscriptionPlans();
        getPlanComparision()
    }, []);

    const getSubscriptionPlans = async () => {
        try {
            setIsLoading(true);
            const res = await subscriptionListApi({ company_id: StorageServices?.getCompanyId() });
            if (res?.responseCode === 200) {
                // Find plans by plan_type instead of relying on array index
                const plans = res?.data?.subscription || [];
                const basicPlan = plans.find(p => p.plan_type === "Basic Plan");
                const premiumPlan = plans.find(p => p.plan_type === "Premium Plan");
                const premiumPlus = plans.find(p => p.plan_type === "Premium+ Plan");
                const enterprisePlan = plans.find(p => p.plan_type === "Enterprise Plan");

                if (res?.data?.subscription.length == 4) {
                    setContainerWidth("1450px");
                    setBoxWidth("calc(25% - 9px)");
                } else if (res?.data?.subscription.length == 3) {
                    setContainerWidth("1200px");
                    setBoxWidth("calc(33.333% - 8px)");
                } else if (res?.data?.subscription.length == 2) {
                    setContainerWidth("800px");
                    setBoxWidth("calc(50% - 9px)");
                } else if (res?.data?.subscription.length == 1) {
                    setContainerWidth("450px");
                    setBoxWidth("100%");
                } else {
                    setContainerWidth("1200px");
                    setBoxWidth("calc(25% - 9px)");
                }


                setSubscriptionPlans({
                    basic: basicPlan,
                    premium: premiumPlan,
                    premiumPlus: premiumPlus,
                    enterprise_Plan: enterprisePlan,

                });

                setSubscriptionList(res?.data)
            } else {
                navigate(-1);
            }
        } catch (error) {
            navigate(-1);
        } finally {
            setIsLoading(false)
        }
    }

    const getPlanComparision = async () => {
        try {
            setIsLoading(true);
            const res = await planComparision({ company_id: StorageServices?.getCompanyId() });
            if (res?.responseCode === 200) {
                console.log(res?.data[0])
                setComparisionPlans(res?.data[0]);

            } else {
                navigate(-1);
            }
        } catch (error) {
            navigate(-1);
        } finally {
            setIsLoading(false)
        }
    }
    // Helper function to calculate original price (assuming 20% discount)
    const calculateOriginalPrice = (discountedPrice) => {
        return Math.round(discountedPrice / 0.8);
    };

    // Helper function to format currency
    const formatPrice = (price) => {
        return price ? `₹ ${price.toLocaleString('en-IN')}` : '₹ 0';
    };

    // Helper function to get features from plan
    const getFeatures = (plan, type) => {
        if (!plan?.plan_type_id?.en_lang?.[0]) return [];
        return plan.plan_type_id.en_lang[0][type] || [];
    };

  

    return (
        <>
            {!isLoading ? <div className='__subscr_main_bx'>
                <button className="back-btn" onClick={() => navigate("/dashboard")}>
                    <FaArrowLeftLong className="back-icon" />
                    Back To Home
                </button>
                <div className="__subscr_container" style={{ width: containerWidth }}>
                    {subscriptionList?.subscription?.length > 0 && < div className='__subscr_planList_bx'>
                        {/* Basic Plan */}
                        {subscriptionPlans?.basic?.plan_name && <div className='__subscr_plansInner_bx' style={{ width: boxWidth }}>
                            <div className='__subscr_heading'>
                                <h4>{subscriptionPlans?.basic?.plan_name || 'Basic Plan'}</h4>
                                <p>Essential plan for small business owners</p>
                            </div>

                            <div className='__subscr_priceBx'>
                                <div className='__subscr_prcLine'>
                                    <del>{formatPrice(subscriptionPlans?.basic?.yearly_rate || 0)}</del>
                                    <p>{formatPrice(subscriptionPlans?.basic?.actual_rate || 0)}</p>
                                    <span>/year</span>
                                </div>

                                <p className='__billPrice'>Billed Annually <span style={{ fontWeight: 500 }}>{formatPrice(subscriptionPlans?.basic?.actual_rate || 6000)}</span>/year </p>

                                <button className='anime-btn __billBuy_btn' onClick={handleBuyBasicPlan}>Buy Basic Plan</button>
                            </div>

                            <div className='__mngBr_subs'>
                                <ul>
                                    <li><p>Manage </p> <span>{`${subscriptionPlans?.basic?.no_of_branch || 1} Branch${subscriptionPlans?.basic?.no_of_branch > 1 ? 'es' : ''}`}</span></li>
                                    <li><p>Access </p> <span>{subscriptionPlans?.basic?.max_no_of_user || 2} Users</span></li>
                                    <li><p>GPS Tracking </p> <span>Not included</span></li>
                                    <li><p>Access on </p> <span>Mobile & Web</span></li>
                                </ul>
                            </div>

                            <div className='__subscr_featureBx'>
                                <p className='__subscrHead'>Features in <span>Basic Plan</span></p>
                                <div className='__subscr_checkListBx'>
                                    <ul>
                                        {getFeatures(subscriptionPlans.basic, 'inclusion').map((feature, index) => (
                                            <li key={index}><span><FaCheck /></span> <p>{feature}</p></li>
                                        ))}
                                    </ul>
                                </div>

                                <div className='__subscr_cancelBx'>
                                    <ul>
                                        {getFeatures(subscriptionPlans.basic, 'exclusion').map((feature, index) => (
                                            <li key={index}><span><RxCross1 /></span> <del>{feature}</del></li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>}

                        {/* Premium Plan */}
                        {subscriptionPlans?.premium?.plan_name && <div className='__subscr_plansInner_bx __subscr_popularBx' style={{ width: boxWidth }}>
                            <div className='__subs_popularTag_bx'>
                                <div className='__subs_popularInnr'>
                                    <img src={testImg} alt="" />
                                    <span>Most Popular</span>
                                </div>
                            </div>

                            <div className='__subscr_heading'>
                                <h4>{subscriptionPlans?.premium?.plan_name || 'Premium Plan'}</h4>
                                <p>For growing teams that need more power & flexibility</p>
                            </div>

                            <div className='__subscr_priceBx'>
                                <div className='__subscr_prcLine'>
                                    <del>{formatPrice(subscriptionPlans?.premium?.yearly_rate || 0)}</del>
                                    <p>{formatPrice(subscriptionPlans?.premium?.actual_rate || 0)}</p>
                                    <span>/year</span>
                                </div>

                                <p className='__billPrice'>Billed Annually <span style={{ fontWeight: 500 }}>{formatPrice(subscriptionPlans?.premium?.actual_rate || 12000)}</span>/year </p>

                                <button className='anime-btn __billBuy_btn' onClick={handleBuyPremiumPlan}>Buy Premium Plan</button>
                            </div>

                            <div className='__mngBr_subs'>
                                <ul>
                                    <li><p>Manage </p> <span>{`${subscriptionPlans?.premium?.no_of_branch || 1} Branch${subscriptionPlans?.premium?.no_of_branch > 1 ? 'es' : ''}`}</span></li>
                                    <li><p>Access </p> <span>{subscriptionPlans?.premium?.max_no_of_user || 5} Users</span></li>
                                    <li><p>GPS Tracking </p> <span>Not included</span></li>
                                    <li>
                                        <p>Access on </p>
                                        <span>
                                            {subscriptionPlans?.premium?.mobile_access > 0 &&
                                                subscriptionPlans?.premium?.web_access > 0 && "Mobile & Web"}

                                            {subscriptionPlans?.premium?.mobile_access > 0 &&
                                                subscriptionPlans?.premium?.web_access === 0 && "Mobile"}

                                            {subscriptionPlans?.premium?.mobile_access === 0 &&
                                                subscriptionPlans?.premium?.web_access > 0 && "Web"}
                                        </span>
                                    </li>

                                </ul>
                            </div>

                            <div className='__subscr_featureBx'>
                                <p className='__subscrHead'>Features in <span>Premium Plan</span></p>
                                <div className='__subscr_checkListBx'>
                                    <ul>
                                        {getFeatures(subscriptionPlans.premium, 'inclusion').map((feature, index) => (
                                            <li key={index}><span><FaCheck /></span> <p>{feature}</p></li>
                                        ))}
                                    </ul>
                                </div>

                                <div className='__subscr_cancelBx'>
                                    <ul>
                                        {getFeatures(subscriptionPlans.premium, 'exclusion').map((feature, index) => (
                                            <li key={index}><span><RxCross1 /></span> <del>{feature}</del></li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>}
                        {/* Premium+ Plan */}
                        {subscriptionPlans?.premiumPlus?.plan_name && <div className='__subscr_plansInner_bx' style={{ width: boxWidth }}>  
                            <div className='__subscr_heading'>
                                <h4>{subscriptionPlans?.premiumPlus?.plan_name || 'Premium+ Plan'}</h4>
                                <p>For growing teams that need more power & flexibility</p>
                            </div>

                            <div className='__subscr_priceBx'>
                                <div className='__subscr_prcLine'>
                                    <del>{formatPrice(subscriptionPlans?.premiumPlus?.yearly_rate || 0)}</del>
                                    <p>{formatPrice(subscriptionPlans?.premiumPlus?.actual_rate || 0)}</p>
                                    <span>/year</span>
                                </div>

                                <p className='__billPrice'>Billed Annually <span style={{ fontWeight: 500 }}>{formatPrice(subscriptionPlans?.premiumPlus?.actual_rate || 6000)}</span>/year </p>

                                <button className='anime-btn __billBuy_btn' onClick={handleBuyPremiumPlusPlan}>Buy Premium+ Plan</button>
                            </div>

                            <div className='__mngBr_subs'>
                                <ul>
                                    <li><p>Manage </p> <span>{`${subscriptionPlans?.premiumPlus?.no_of_branch || 1} Branch${subscriptionPlans?.premiumPlus?.no_of_branch > 1 ? 'es' : ''}`}</span></li>
                                    <li><p>Access </p> <span>{subscriptionPlans?.premiumPlus?.max_no_of_user || 2} Users</span></li>
                                    <li><p>GPS Tracking </p> <span>Not included</span></li>
                                    <li><p>Access on </p> <span>Mobile & Web</span></li>
                                </ul>
                            </div>

                            <div className='__subscr_featureBx'>
                                <p className='__subscrHead'>Features in <span>Premium+ Plan</span></p>
                                <div className='__subscr_checkListBx'>
                                    <ul>
                                        {getFeatures(subscriptionPlans.premiumPlus, 'inclusion').map((feature, index) => (
                                            <li key={index}><span><FaCheck /></span> <p>{feature}</p></li>
                                        ))}
                                    </ul>
                                </div>

                                <div className='__subscr_cancelBx'>
                                    <ul>
                                        {getFeatures(subscriptionPlans.premiumPlus, 'exclusion').map((feature, index) => (
                                            <li key={index}><span><RxCross1 /></span> <del>{feature}</del></li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>}
                        {/* Enterprise Plan */}
                        {subscriptionPlans?.enterprise_Plan?.plan_name && <div className='__subscr_plansInner_bx' style={{ width: boxWidth }}>
                            <div className='__subscr_heading'>
                                <h4>{subscriptionPlans?.enterprise_Plan?.plan_name || 'Enterprise Plan'}</h4>
                                <p>Fully customizable for large-scale operations</p>
                            </div>

                            <div className='__subscr_priceBx'>
                                <div className='__subscr_prcLine'>
                                    <del>{formatPrice(subscriptionPlans?.enterprise_Plan?.yearly_rate || 0)}</del>
                                    <p>{formatPrice(subscriptionPlans?.enterprise_Plan?.actual_rate || 0)}</p>
                                    <span>/year</span>
                                </div>

                                <p className='__billPrice'>Billed Annually <span style={{ fontWeight: 500 }}>{formatPrice(subscriptionPlans?.enterprise_Plan?.actual_rate || 10000)}</span>/year </p>

                                <button className='anime-btn __billBuy_btn' onClick={handleBuyEnterPrisePlan}>Contact us</button>
                            </div>

                            <div className='__mngBr_subs'>
                                <ul>
                                    <li><p>Manage </p> <span>{subscriptionPlans?.enterprise_Plan?.no_of_branch ? `${subscriptionPlans?.enterprise_Plan?.no_of_branch} branches` : 'Unlimited branches'}</span></li>
                                    <li><p>Access </p> <span>{subscriptionPlans?.enterprise_Plan?.max_no_of_user || 5} Users</span></li>
                                    <li><p>GPS Tracking </p> <span>Included</span></li>
                                    <li><p>Access on </p> <span>Mobile & Web</span></li>
                                </ul>
                            </div>

                            <div className='__subscr_featureBx'>
                                <p className='__subscrHead'>Features in <span>Enterprise Plan</span></p>
                                <div className='__subscr_checkListBx'>
                                    <ul>
                                        {getFeatures(subscriptionPlans.enterprise_Plan, 'inclusion').map((feature, index) => (
                                            <li key={index}><span><FaCheck /></span> <p>{feature}</p></li>
                                        ))}
                                    </ul>
                                </div>

                                {getFeatures(subscriptionPlans.enterprise_Plan, 'exclusion').length > 0 && (
                                    <div className='__subscr_cancelBx'>
                                        <ul>
                                            {getFeatures(subscriptionPlans.enterprise_Plan, 'exclusion').map((feature, index) => (
                                                <li key={index}><span><RxCross1 /></span> <del>{feature}</del></li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>}


                    </div> } 
                    {subscriptionList?.subscription?.length == 0 &&  <div className='__subscr_planList_bx_current'>
                        {/* Premium Plan */}
                        <div className='__subscr_plansInner_bx __subscr_popularBx'>
                            <div className='__subs_popularTag_bx'>
                                <div className='__subs_popularInnr'>
                                    <img src={testImg} alt="" />
                                    <span>Current Plan</span>
                                </div>
                            </div>

                            <div className='__subscr_heading'>
                                <h4>{subscriptionList?.current_plan?.plan_name || 'Premium Plan'}</h4>
                                <p>For growing teams that need more power & flexibility</p>
                            </div>

                            <div className='__subscr_priceBx'>
                                <div className='__subscr_prcLine'>
                                    <del>{formatPrice(subscriptionList?.current_plan?.yearly_rate || 0)}</del>
                                    <p>{formatPrice(subscriptionList?.current_plan?.actual_rate || 0)}</p>
                                    <span>/year</span>
                                </div>

                                <p className='__billPrice'>Billed Annually <span style={{ fontWeight: 500 }}>{formatPrice(subscriptionList?.current_plan?.yearly_rate || 12000)}</span>/year </p>


                            </div>

                            <div className='__mngBr_subs'>
                                <ul>
                                    <li><p>Manage </p> <span>{`${subscriptionList?.current_plan?.no_of_branch || 1} Branch${subscriptionList?.current_plan?.no_of_branch > 1 ? 'es' : ''}`}</span></li>
                                    <li><p>Access </p> <span>{subscriptionList?.current_plan?.max_no_of_user || 5} Users</span></li>
                                    <li><p>GPS Tracking </p> <span>Not included</span></li>
                                    <li><p>Access on </p> <span>Mobile & Web</span></li>
                                </ul>
                            </div>


                        </div>
                    </div>}

                    

                    {subscriptionList?.current_plan?.plan_type == "free plan" && <div className='__subscr_freePlan_bx'>
                        <div className='__subscr_checkListBx'>
                            <div className='__subscr_heading'>
                                <h4>Free</h4>
                                <p>For trying out and managing basic operations</p>
                            </div>

                            <ul>
                                <li><span><FaCheck /></span> <p>1 user, 1 branch</p></li>
                                <li><span><FaCheck /></span> <p>Mobile access</p></li>
                                <li><span><FaCheck /></span> <p>100 LR & 100 trips/month</p></li>
                                <li><span><FaCheck /></span> <p>E-way bill & extension: 5/day</p></li>
                                <li><span><FaCheck /></span> <p>Driver SIM tracking: 10/day</p></li>
                            </ul>
                        </div>
                    </div>}
                </div>
                {/* Comparison Table */}
                {(subscriptionList?.subscription?.length > 0 && comparisionPlans?.comparision?.length) && <ComparisonTable comparisonData={comparisionPlans?.comparision} subscriptionList={subscriptionList?.subscription} />}
            </div > : <div colSpan="100%" className="loaderBg" style={{ textAlign: "center" }}>
                <Loading />
            </div>
            }
        </>
    )
}

export default Subscription